import React, { useCallback, useEffect, useState } from 'react';
import {
  exchangeSectionStyle,
  exchangeTitleStyle,
  type ExchangeTheme,
} from '../features/kiwoom/kiwoomTheme';

const chevron: React.CSSProperties = {
  fontSize: '0.75rem',
  opacity: 0.75,
  marginLeft: 8,
  userSelect: 'none',
};

const ExchangeParentSection: React.FC<{
  title: string;
  theme: ExchangeTheme;
  defaultOpen?: boolean;
  storageKey?: string;
  className?: string;
  children: React.ReactNode;
}> = ({ title, theme, defaultOpen = true, storageKey, className, children }) => {
  const persistKey = storageKey ?? `exchange-section-${theme}-open`;

  const [open, setOpen] = useState(() => {
    try {
      const raw = localStorage.getItem(persistKey);
      if (raw === '0') return false;
      if (raw === '1') return true;
    } catch {
      /* ignore */
    }
    return defaultOpen;
  });

  useEffect(() => {
    try {
      localStorage.setItem(persistKey, open ? '1' : '0');
    } catch {
      /* ignore */
    }
  }, [open, persistKey]);

  const toggle = useCallback(() => setOpen((v) => !v), []);

  return (
    <section style={exchangeSectionStyle(theme)} className={className}>
      <button
        type="button"
        onClick={toggle}
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          margin: 0,
          padding: 0,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
          textAlign: 'left',
        }}
        aria-expanded={open}
      >
        <h2 style={{ ...exchangeTitleStyle(theme), margin: 0, flex: 1 }}>
          {title}
        </h2>
        <span style={chevron} aria-hidden>
          {open ? '▼' : '▶'}
        </span>
      </button>
      {open && <div style={{ marginTop: 16 }}>{children}</div>}
    </section>
  );
};

export default ExchangeParentSection;
